import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import { ToggleButton, ToggleButtonGroup } from '@sumologic/yama-ds-components';

const ToggleButtons = props => {
    const { buttons, title, selectedValue } = props;
    const [value, setValue] = useState(selectedValue);
    useEffect(() => {
        setValue(selectedValue);
    }, [selectedValue]);
    return buttons?.length ? (
        <span className="toggle-buttons" data-testid={'test-toggle-buttons'} onClick={e => e.stopPropagation()}>
            {title?.length > 0 && <b className="title">{title}</b>}
            <ToggleButtonGroup
                size="small"
                value={value}
                exclusive
                onChange={(e, newValue) => {
                    if (newValue !== null) {
                        setValue(newValue);
                        buttons.find(
                            (btn, i) => (btn[2] ?? i) === newValue
                        )?.[1]?.();
                    }
                }}
            >
                {buttons.map((button, index) => {
                    const buttonLabel = button[0];
                    const buttonValue = button[2] ?? index;
                    return buttonLabel ? (
                        <ToggleButton
                            key={index}
                            value={buttonValue}
                            data-testid={'test-toggle-button'}
                        >
                            <span className="text">{buttonLabel}</span>
                        </ToggleButton>
                    ) : null; // no label no button
                })}
            </ToggleButtonGroup>
        </span>
    ) : null;
};

ToggleButtons.propTypes = {
    buttons: PropTypes.array.isRequired, //  [ text(:String|Element), action(:Function) ]
    title: PropTypes.string,
    selectedValue: PropTypes.any
};

ToggleButtons.defaultProps = {
    value: null
};

export default ToggleButtons;
